module.exports = __webpack_public_path__ + "img/step_2.453bead9.png";